<template>
  <v-row>
    <v-col cols="12" style="padding: 0px 10px">
      <v-card color="grey lighten-4" flat height="100">
        <v-toolbar color="primary" dark>
          <v-menu offset-y>
            <template v-slot:activator="{ on }">
              <v-app-bar-nav-icon v-on="on"></v-app-bar-nav-icon>
            </template>
            <v-list>
              <v-list-item v-for="(item, index) in snow" :key="index" @click="Fct_DashingSnow(item)">
                <v-list-item-icon v-if="item.ico" class="mr-2">
                  <v-icon size="24">
                    {{ item.ico }}
                  </v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>
                    {{ item.title }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-menu>

          <v-toolbar-title>{{ $COMPANY }} - Engagements | {{ T_SA_Message }}{{ T_welcomeMessage }}</v-toolbar-title>
          <v-spacer></v-spacer>

          <div v-if="!B_NoPeriod" style="margin: 0px 20px 0px 0px">
            <span style="margin-right: 10px">Année</span>
            <v-menu offset-y>
              <template v-slot:activator="{ on }">
                <v-btn v-on="on" color="#444" style="color: #fff" title="Année">
                  {{ T_PeriodsSelected }}
                </v-btn>
              </template>
              <v-list>
                <v-list-item v-for="(item, index) in TT_PeriodsList" :key="index" @click="Fct_NavBarPeriodsChange(index)">
                  <v-list-item-title>{{ item }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </div>

          <div v-if="!B_NoPeriod" style="margin: 0px 20px 0px 0px">
            <span style="margin-right: 10px">Compte analytique</span>
            <v-menu offset-y>
              <template v-slot:activator="{ on }">
                <v-btn v-on="on" color="#444" style="color: #fff" title="Compte analytique">
                  {{ T_AnalyticalAccountsSelected }}
                </v-btn>
              </template>
              <v-list>
                <v-list-item v-for="(item, index) in TT_AnalyticalAccountsList" :key="index" @click="Fct_NavBarAnalyticalAccountsChange(index)">
                  <v-list-item-title>{{ item }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </div>

          <!--<v-menu offset-y>
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" icon>
                <v-icon>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item v-for="(item, index) in lava" :key="index" @click="Fct_BlazingLava(index)">
                <v-list-item-title>{{ item.title }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>-->

          <v-btn text @click="Fct_BlazingLava(0)">Déconnexion</v-btn>
        </v-toolbar>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { MixinPeriods } from "../mixin/MixinPeriods";
import { MixinAnalyticalAccounts } from "../mixin/MixinAnalyticalAccounts";

export default {
  mixins: [MixinPeriods, MixinAnalyticalAccounts],
  name: "Nav-Bar",
  props: { B_NoPeriod: { type: Boolean } },
  data: () => ({
    title: "NavBar",
    period: "Loading",
    snow: [
      { ico: "mdi-currency-eur", title: "Budget" },
      { ico: "mdi-key", title: "Autorisation" },
      { ico: "mdi-handshake", title: "Engagement" },
      { ico: "mdi-account-check", title: "Approbation" },
      { ico: "mdi-cog", title: "Configuration" }
    ],
    lava: [{ title: "Déconnexion" }],
    TO_PeriodList: [],
    T_welcomeMessage: "",
    B_SuperAdmin: false
  }),
  computed: {
    T_SA_Message: function() {
      if (this.B_SuperAdmin) {
        return "Administrateur | ";
      } else {
        return "";
      }
    }
  },
  methods: {
    Fct_DashingSnow(O_Jingle) {
      switch (O_Jingle.title) {
        case "Budget":
          this.$router.push({ name: "Budget" });
          break;
        case "Autorisation":
          this.$router.push({ name: "Autorisation" });
          break;
        case "Engagement":
          this.$router.push({ name: "Engagement" });
          break;
        case "Approbation":
          this.$router.push({ name: "Approbation" });
          break;
        case "Configuration":
          this.$router.push({ name: "Configuration" });
          break;
      }
    },
    Fct_BlazingLava(L_Burn) {
      switch (L_Burn) {
        case 0:
          this.$cookies.remove("BackEndToken");
          this.$router.push({ name: "Connect" });
          break;
      }
    },
    Fct_NavBarPeriodsChange(L_index) {
      this.Fct_PeriodsChange(L_index);
      this.Fct_AnalyticalAccountsLoad(this.$cookies.get("Period"), true).then(function() {
        location.reload();
      });
    },
    Fct_NavBarAnalyticalAccountsChange(L_index) {
      this.Fct_AnalyticalAccountsChange(L_index);
      location.reload();
    }
  },
  created() {
    this.Fct_PeriodsGet();
    this.Fct_AnalyticalAccountsGet();
    this.T_welcomeMessage = this.$cookies.get("UserName");
    var T_SuperAdmin = this.$cookies.get("UserAdmin");
    this.B_SuperAdmin = T_SuperAdmin == "true";
    if (!this.B_SuperAdmin) {
      this.snow = [{ title: "Budget" }, { title: "Engagement" }, { title: "Approbation" }];
    }
  }
};
</script>
